import { useInboxDragStore } from "../../stores/index.js";

/**
 * Floating chip that follows the finger while an inbox item is being dragged
 * onto the calendar (mobile). Mounted once in the Shell, above everything.
 */
export function InboxDragGhost() {
  const { active, title, x, y, preview } = useInboxDragStore();
  if (!active || preview) return null;
  return (
    <div
      className="pointer-events-none fixed z-[70] max-w-[60vw] truncate rounded-md border-2 border-primary bg-card px-3 py-2 text-sm font-medium shadow-xl ring-2 ring-primary/40"
      style={{ left: x, top: y, transform: "translate(-50%, -130%)" }}
    >
      {title.trim() || "Task"}
    </div>
  );
}
